"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Cookies = require("js-cookie");
var firebase_1 = require("firebase");
var tokenService = require("./userDetails");
function checkStatus(firebaseAuth, authServerUrl, authClientUrl, redirectUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var cssToken, statusRequestConfig, authStatusResponse, authToken, tokenResult, userDetails, tenant, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cssToken = Cookies.get('csst');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 11, , 12]);
                    if (!cssToken) return [3 /*break*/, 9];
                    statusRequestConfig = {
                        headers: { Authorization: "Bearer ".concat(cssToken) },
                        withCredentials: true
                    };
                    return [4 /*yield*/, axios_1.default.post("".concat(authServerUrl, "/auth/status"), {}, statusRequestConfig)];
                case 2:
                    authStatusResponse = _a.sent();
                    if (!(authStatusResponse.status === 403)) return [3 /*break*/, 3];
                    throw 'failed to check auth status';
                case 3:
                    if (!(authStatusResponse.status === 200)) return [3 /*break*/, 8];
                    authToken = authStatusResponse.data.token;
                    if (!authToken) return [3 /*break*/, 7];
                    return [4 /*yield*/, firebaseAuth.setPersistence(firebase_1.default.auth.Auth.Persistence.SESSION)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, firebaseAuth.signInWithCustomToken(authToken)];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, firebaseAuth.currentUser.getIdTokenResult()];
                case 6:
                    tokenResult = _a.sent();
                    userDetails = tokenResult.claims.userDetails;
                    tenant = {
                        id: userDetails.defaultTenant.tenantId,
                        tenantName: userDetails.defaultTenant.tenantName,
                        url: userDetails.defaultTenant.url,
                        tenantLevel: userDetails.defaultTenant.tenantLevel,
                        availableProjects: userDetails.defaultTenant.availableProjects
                    };
                    tokenService.setUserDetails(userDetails);
                    tokenService.setTenant(tenant);
                    tokenService.setAccessType(userDetails.defaultTenant.accessType);
                    return [2 /*return*/, true];
                case 7: throw 'failed to check auth status';
                case 8: return [3 /*break*/, 10];
                case 9: throw 'cross-site scripting token not present';
                case 10: return [3 /*break*/, 12];
                case 11:
                    err_1 = _a.sent();
                    window.location.href = "".concat(authClientUrl, "?ref=").concat(redirectUrl);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/, false];
            }
        });
    });
}
exports.default = checkStatus;
//# sourceMappingURL=checkStatus.js.map